import React, { memo } from "react";
import styles from "./styles/Product.module.css";
import cx from "classnames";
import { Spin } from "antd";
import { SearchOutlined } from "@ant-design/icons";

const Product = ({ product, loadingDeta, openDataCard }) => {
  const {
    quantity,
    name,
    isCard,
    cardData,
    product_categories = [],
    comments,
    unit_price,
    price,
  } = product;

  // Calcular el total real considerando base + todas las opciones
  const calculateRealTotal = () => {
    // Precio unitario base × cantidad
    const basePrice = unit_price || price || 0;
    const baseTotal = parseFloat(basePrice) * parseInt(quantity || 1);
    
    // Suma de TODOS los extras
    let extrasTotal = 0;
    product_categories.forEach(category => {
      if (category.extras && Array.isArray(category.extras)) {
        category.extras.forEach(extra => {
          const extraPrice = parseFloat(extra.price || 0);
          const extraQuantity = parseInt(extra.quantity || 1);
          extrasTotal += extraPrice * extraQuantity;
        });
      }
    });
    
    return (baseTotal + extrasTotal).toFixed(2);
  };

  return (
    <div className={styles.product}>
      <div className={cx(styles.productName, styles.green)}>
        <span>{`(${quantity}) ${name} - `}</span>
        {isCard && (
          <button
            disabled={loadingDeta}
            className={styles.btnCardIcon}
            onClick={() => openDataCard(name, cardData)}
          >
            {loadingDeta ? <Spin size="small" /> : <SearchOutlined />}
          </button>
        )}
      </div>

      <div className={styles.details}>
        {product_categories.map((category) => (
          <div key={category.id}>
            <span>{category.name}</span>
            <div className={styles.extraLine}>
              {category.extras && category.extras.map((extra) => (
                <span key={extra.id} className={styles.extraItem}>
                  <span className={styles.bullet}>•</span>
                  <span className={styles.extraName}>{extra.name}</span>
                  <span className={styles.extraPrice}>
                    ${parseFloat(extra.price || 0).toFixed(2)}
                  </span>
                </span>
              ))}
            </div>
          </div>
        ))}

        {comments && (
          <div className={styles.annotations}>
            <span>
              <span className={styles.labelNotes}>Nota:</span> {comments}
            </span>
          </div>
        )}
      </div>

      <div className={styles.totalProduct}>
        <span className={styles.price}>
          {`$${calculateRealTotal()}`}
        </span>
      </div>
    </div>
  );
};

export default memo(Product);
